// API Configuration
// Uses environment variables for production/development flexibility

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

export default API_BASE_URL;
